<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} de {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Buscar..." />
          <vs-button icon-pack="feather" icon="icon-user" class="mr-4" :to="{ name: 'usuariosNuevo' }">Nuevo</vs-button>

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

      <div class="vx-col w-full flex">&nbsp;</div>

      <div class="vx-col w-full flex justify-end">
        <vs-button icon-pack="feather" icon="icon-user" class="mr-4" :to="{ name: 'usuariosNuevo' }">Nuevo</vs-button>
      </div>

    </div>

  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import localeEs from '@/locale/aggrid/es.locale'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'


export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererActions
  },
  data () {
    return {
      searchQuery: '',
      supervisores: [],

      // AgGrid
      gridApi: null,
      gridOptions: {
        localeTextFunc (key, defaultValue) {          
          return localeEs[key] || defaultValue
        }
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          checkboxSelection: false,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false
        },
        {
          headerName: 'Username',
          field: 'username',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Apellidos',
          field: 'apellidos',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Nombre',
          field: 'nombre',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Perfil',
          field: 'roles',
          filter: true,
          cellRendererFramework: 'CellRendererLink',
          valueGetter (params) {       
            let rol = 'USUARIO'     
            params.data.roles.forEach((elemento) => {
              if (elemento === 'ROLE_ADMIN') {
                rol = 'ADMINISTRADOR'
              } else if (elemento === 'ROLE_SUPERVISOR' && rol !== 'ADMINISTRADOR') {
                rol = 'SUPERVISOR'
              } else if (elemento === 'ROLE_COMERCIAL' && (rol !== 'ADMINISTRADOR' || rol !== 'SUPERVISOR')) {
                rol = 'COMERCIAL'
              }
            })
            return rol
          }
        },
        {
          headerName: 'Activo',
          field: 'activo',
          filter: true,
          cellRendererFramework: 'CellRendererLink',
          valueGetter (params) {            
            return params.data.activo ? 'Si' : 'No'
          }
        },
        {
          headerName: 'Supervisor',
          field: 'supervisor',
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Acciones',
          field: 'transactions',
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererActions
      }
    }
  },
  computed: {
    usersData () {
      const usuarios = JSON.parse(JSON.stringify(this.$store.state.userManagement.users))
      const supervisores = this.supervisores
      usuarios.forEach(usuario => {
        supervisores.forEach(supervisor => {
          if (usuario.supervisor === supervisor.id) usuario.supervisor = `${supervisor.nombre} ${supervisor.apellidos}`
        })
      })
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      return usuarios
    },
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'Todos', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridApi.sizeColumnsToFit()

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  async created () {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
    await this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })

    // Necesitamos todos os supervisores, non só os activos porque senon nos inactivos mostraríase na lista o id en lugar do nome
    await this.$store.dispatch('userManagement/getSupervisores')
      .then(() => {
        this.supervisores = this.$store.state.userManagement.supervisores
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
